import { render, staticRenderFns } from "./SubmitForApprovalModal.vue?vue&type=template&id=2dc9865d&"
import script from "./SubmitForApprovalModal.vue?vue&type=script&lang=js&"
export * from "./SubmitForApprovalModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitForApprovalModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports